import * as React from 'react';
import Grid from '@material-ui/core/Grid';

interface InvitationTextFieldProps {
    email: string,
    firstName: string,
    lastName: string,
    changeEmail: (e: React.ChangeEvent<HTMLInputElement>) => void,
    changeName: (e: React.ChangeEvent<HTMLInputElement>) => void
}

class InvitationTextField extends React.Component <InvitationTextFieldProps, {}> {
    public render() {
        return (
            <div className="invitationTextField">
                <Grid className="invitationInput" item xs={6}>
                    <input
                        type="text"
                        placeholder="Add Company User email"
                        value={this.props.email}
                        onChange={(e) => this.props.changeEmail(e)}/>
                </Grid>
                <Grid className="invitationInput" item xs={3}>
                    <input
                        type="text"
                        placeholder="First Name"
                        name="firstName"
                        value={this.props.firstName}
                        onChange={(e) => this.props.changeName(e)}/>
                </Grid>
                <Grid className="invitationInput" item xs={3}>
                    <input
                        type="text"
                        placeholder="Last Name"
                        name="lastName"
                        value={this.props.lastName}
                        onChange={(e) => this.props.changeName(e)}/>
                </Grid>
            </div>
        );
    }
}

export default InvitationTextField;



// WEBPACK FOOTER //
// ./src/Components/Contact/Invitation/InvitationTextField.tsx